import React, { useState } from "react";
import { Button } from "@mui/material";
import { Add, Remove, ShoppingBag } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { fetchAddToCartItem } from "../../actions/global";

const QtyInputProduct = ({ item }) => {
  const [qty, setQty] = useState(1);
  const dispatch = useDispatch();

  const handleDecrease = () => {
    setQty((prev) => Math.max(1, prev - 1));
  };

  const handleIncrease = () => {
    setQty((prev) => Math.min(item.quantity, prev + 1));
  };

  const addToCartItem = () => {
    const cartItem = {
      productId: item?.id,
      quantity: qty,
    };

    dispatch(fetchAddToCartItem(cartItem));
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      {/* QTY HOLDER */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          border: "1px solid #ddd",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <Button
          onClick={handleDecrease}
          disabled={qty <= 1}
          variant="text"
          style={{
            minWidth: "40px",
            height: "40px",
            borderRight: "1px solid #ddd",
            borderRadius: 0,
          }}
        >
          <Remove style={{ color: "#000" }} />
        </Button>

        <div
          style={{
            width: "50px",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "18px",
          }}
        >
          {qty}
        </div>

        <Button
          onClick={handleIncrease}
          disabled={qty >= item.quantity}
          variant="text"
          style={{
            minWidth: "40px",
            height: "40px",
            borderLeft: "1px solid #ddd",
            borderRadius: 0,
          }}
        >
          <Add style={{ color: "#000" }} />
        </Button>
      </div>

      {/* ADD TO CART BTN */}
      <Button
        variant="contained"
        onClick={() => addToCartItem()}
        startIcon={<ShoppingBag />}
        style={{
          backgroundColor: "#ff6206",
          color: "white",
          padding: "12px 28px",
          fontWeight: "bold",
          fontSize: "12px",
          borderRadius: "6px",
        }}
      >
        DODAJ U KORPU
      </Button>
    </div>
  );
};

export default QtyInputProduct;
